import { brandConfiguration } from "@/brands/config";
import { getStoredVisitorCode } from "@/utils/kameleoon/getStoredVisitorCode";
import { useEffect, useRef, useState } from "react";
import { makeKameleoonClient } from "./makeKameleoonClient";
/**
 * Initializes and returns a Kameleoon client along with its visitor code.
 * @param shouldInit - whether consent or previous consent is present
 */
export function useKameleoonClient(shouldInit) {
    const clientRef = useRef(null);
    const [visitorCode, setVisitorCode] = useState(null);
    useEffect(() => {
        if (!shouldInit || clientRef.current)
            return;
        (async () => {
            try {
                const kameleoonConf = brandConfiguration.kameleoon;
                const siteCode = kameleoonConf === null || kameleoonConf === void 0 ? void 0 : kameleoonConf.siteCode;
                const env = kameleoonConf === null || kameleoonConf === void 0 ? void 0 : kameleoonConf.env;
                if (!siteCode || !env)
                    return;
                const client = makeKameleoonClient(siteCode, env);
                await client.initialize();
                if (!client.isInitialized()) {
                    console.warn("[Kameleoon] Client failed to initialize.");
                    return;
                }
                // capture visitor code immediately after initialization
                let visitorCode = getStoredVisitorCode();
                if (!visitorCode) {
                    visitorCode = client.getVisitorCode();
                }
                setVisitorCode(visitorCode);
                // store reference for further API calls
                clientRef.current = client;
            }
            catch (err) {
                console.error("[Kameleoon] Error initializing client:", err);
            }
        })();
    }, [shouldInit]);
    return {
        client: clientRef.current,
        visitorCode,
    };
}
